import Vue from 'vue/dist/vue.esm';
import template from './tooltip_template.slim';

Vue.component('tooltip', {
  mixins: [template],
  props: [
    'message',
  ]
});
